import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import About from '../../menhome/About';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Aboutleft from '../About/Aboutleft'
const faqData = [
  
    {
        id: 'headingOne',
        question: 'About Us',
        answer: (
            <>
                <About />
                            
                <p className='mt-3 caboutus'>The IIT system has 23 Institutions of Technology. The IITs are well known both nationally and internationally for excellence in education and research in engineering and science.  The research and academic programs are handled by outstanding faculty members and the best students in the country take admission to the IITs. The prospective students have to appear in the Joint Entrance Examination (JEE) conducted on all India basis, which around 800,000 students take based on which around 200,000 are eligible for the JEE-Advanced examination. About 16,000 students are offered admissions in the B. Tech program in the IITs. Over the years, IITs have created world class educational platforms dynamically sustained through internationally recognized research based on excellent infrastructural facilities. The faculty and alumni of IITs have made huge impact in all sectors of society, both in India and abroad. The institutes are globally recognized as centers of academic excellence and are reputed for the outstanding caliber of the students graduating from these Institutions.<br /><br />
                            Indian Institute of Technology Tirupati is the first among the 3rd phase of IITs, announced in 2014, to have its foundation stone laid in March 2015. IIT Tirupati started functioning with the support of its mentoring institute, IIT Madras, from the academic year of 2015-16. The academic program was launched in August 2015 by admitting students in the B.Tech programme in the fields of Civil Engineering, Computer Science &amp; Engineering, Electrical Engineering, and Mechanical Engineering. The research programmes namely, the MS and Ph.D. programmes have started from the academic year 2017.  Subsequently, the new B.Tech programme in Chemical Engineering started in August 2018. The  M.Tech programs in Mechanical, Electrical, and Computer Science disciplines have also been launched from August 2018. The M.Sc programme in Mathematics was started in August 2019. The latest addition is the Master of Public Policy (MPP) programme, which was launched in 2022 to meet the growing demand for policy professionals in India. The curriculum for various programmes have an emphasis on theoretical knowledge and practice-oriented laboratories. Courses are well planned to nurture innovation, creativity, quality, teamwork, communication skills, ethics, and societal interaction.
                </p>
                <p className="caboutus">
                    IIT Tirupati operated from the temporary campus on Tirupati – Renigunta Road initially, but all campus activities moved to Yerpedu campus as of 01 August, 2022. The Stage 1A Transit Campus (over 36 acres) is integrated into the Permanent Campus spanning over 548.3 acres provided by the Government of Andhra Pradesh in Merlapaka Village on Yerpedu-Venkatagiri Highway. This campus was inaugurated by Honourable Minister of Human Resource Development Shri Ramesh Pokhriyal ‘Nishank‘ on 13th August 2019. The Master Plan for the 12,000-student campus, has been completed. It shall include four zones, namely, Academic Zone, Hostel Zone, Housing Zone, and Recreational Zone, along with a transit campus (that is integrated with the permanent campus). It is planned to build the permanent campus in phases. A complete campus to cater to 2,500 students, 250 faculty members and 275 staff members is planned to be built by 2024. The construction is to be taken up in two stages. In Stage 1, to be completed by 2021, buildings and facilities to cater to 1,250 students and 120 faculty members are to be completed, and all operations are to be moved to the permanent campus. Subsequently, the campus shall be developed in various phases growing over 25-30 years to cater to a 12,000-student campus.
                    Currently,  the campus has air-conditioned classrooms of various capacities such as 40, 60, 90 and 120 seater classrooms to conduct classes. Also, high-end Laboratories of Civil, Mechanical, and Electrical engineering are operational at the transit campus. In addition, computer Labs, the health center, and the central library are available to facilitate students. The transit campus also hosts various indoor and outdoor sports facilities such as Badminton, Table Tennis, Gym,  and Volleyball, Basketball, and Football. Supporting facilities such as common dining, laundry, and stationery shops are also available.  For the upcoming academic year, July 2020, new hostel building construction is going on, which will complete the end of May 2020. It will accommodate around 180 students, including common facilities such as common rooms, study rooms, etc

                </p>
                <div className="tm-highlight-block tm-highlight-right">IIT Tirupati has a high potential to be an Academic and Research Institute of great repute.</div>
                <p  className="caboutus">

                    The Government of Andhra Pradesh is nurturing Tirupati as knowledge hub of the State. The new IISER Tirupati permanent campus is to come up within about 3 Kms from the IIT Tirupati campus. Many established Institutions such as  Sri Venkateswara University, Sri Venkateswara Medical College, Sri Venkateswara Institute of Medical Sciences (SVIMS), Sri Padmavathi Mahila Visvavidyalayam, Sanskrit University, etc. are located in Tirupati. An upcoming integrated business city “ Sri City” nearby and the Satish Dhawan Space Center (SHAR) in Sriharikota being close by, gives it a technological edge. Tirupati town being one of an important cites in Andhra Pradesh with its Airport and proximity to Chennai and Bengaluru, gives it excellent connectivity.
                </p>   
            </> 
          ),
    },

    {
        id: 'headingTwo',
        question: 'Vision',
        answer: (
            <>
                <div className="caboutus px-3 mb-4">
                    <h4>Vision :</h4>
                    {/* <p>IIT Tirupati will be a leading center of higher education with global outlook and local relevance.</p> */}
                    <ul className="myulcustarrow">
                        <li>To contribute to society through excellence in scientific and technical education and research.</li>
                        <li>To serve as a valuable resource for industry and society.</li>
                    </ul>
                    {/*  */}
                </div>
              

            </>
        ),
    },

    {
        id: 'headingThree',
        question: 'Mission',
        answer: (
            <>
            
                <div className="caboutus px-3 mt-4 mb-4">
                    <h4>Mission : </h4>
                    <ul className="myulcustarrow">
                        <li>To generate new knowledge by engaging in cutting-edge research and to promote academic growth by offering state-of-the-art undergraduate, postgraduate and doctoral programmes.</li>
                        <li>To identify, based on an informed perception of Indian, regional and global needs, areas of specialisation upon which the Institute can concentrate. </li>
                        <li>To develop human potential to its fullest extent so that intellectually capable and imaginatively gifted leader can emerge in a range of professions</li>
                    </ul>
                </div>

              

            </>
        ),
    },

    {
        id: 'headingFour',
        question: 'Objectives',
        answer: (
            <>
               
                <div className="caboutus px-3 mt-4 mb-4">
                    <h4>Objectives : </h4>
                    <ul className="myulcustarrow">
                        <li>To provide the best educational infrastructure for imparting high class education in science and technology and a creative atmosphere for inter-disciplinary research both by the students and the faculty.</li>
                        <li>To increase the student capacity to meet the growing demands for industry. </li>
                        <li>To maintain global standards in student-faculty ratio, research output, publications in journals and placement of students.</li>
                        <li>To participate in and contribute to nation building through various flagship schemes of the Government of India/State Governments requiring technological interventions thereby spurring economic growth for the welfare of the masses.</li>
                        <li>To provide research and development consultancy, which will foster healthy industry-academia partnership, thereby providing a competitive edge to the indigenous manufacturing.</li>
                    </ul>
                </div>

            </>
        ),
    },


    {
        id: 'headingFive',
        question: 'NIRF',
        answer: (
            <div className="caboutus px-3">
                <div aria-hidden="false" className="uk-active">
                    <h4>
                        NATIONAL INSTITUTIONAL RANKING FRAMEWORK (NIRF)
                    </h4>
                    <p>
                        The National Institutional Ranking Framework (NIRF), approved by the Ministry of Human Resource Development (MHRD), outlines a methodology to rank institutions across the country. The methodology draws from the overall recommendations and broad understanding arrived at by a Core Committee set up by MHRD, to identify the parameters for ranking various universities and institutions. These parameters broadly cover "Teaching, Learning and Resources," "Research and Professional Practices," "Graduation Outcomes," "Outreach and Inclusivity," and "Perception."
                    </p>
                    <h5>
                        Data submitted by IIT Tirupati for NIRF
                    </h5>
                    <ul className="myulcustarrow fw-bold">
                        <li> <Link className='c-link' to="https://files.iittp.ac.in/pdfs/nirf/2024/NIRF_Engineering_2024.pdf" target="_blank"> NIRF Engineering Report - 2024</Link></li>
                        <li> <Link className='c-link' to="https://files.iittp.ac.in/pdfs/nirf/2024/NIRF_Overall_2024.pdf" target="_blank"> NIRF Overall Report - 2024</Link></li>
                        <li> <Link className='c-link' to="https://files.iittp.ac.in/pdfs/nirf/2024/NIRF_Innovation_2024.pdf" target="_blank"> NIRF Innovation Report - 2024</Link></li>
                        <li> <Link className='c-link' to="https://files.iittp.ac.in/pdfs/nirf/NIRF_Report-2023.pdf" target="_blank"> NIRF Engineering Report - 2023</Link></li>
                        <li> <Link className='c-link' to="https://files.iittp.ac.in/pdfs/nirf/NIRF_Report-2022.pdf" target="_blank"> NIRF Engineering Report - 2022</Link></li>
                    </ul>
                </div>
            </div>

          ),
    },

];


function AboutEle (props) {
    // const [video, setVideo] = useState();

    const [activeIndex, setActiveIndex] = useState(props.activeIndex);

    const handleToggle = (index) => {
       
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    return (
        <>
        <Header/>
        
        <Breadcrumb title="Home" subtitle={props.title}/>

        <section className="project-detail">
         <div className="container">
                    <div className="row">

                        <div className="col-lg-4 col-md-4 c-left custom-padding-color">
                            <Aboutleft activeIndex={activeIndex} handleToggle={handleToggle} /> 
                        </div>
                        
                        <div className="col-lg-8 col-md-8  wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                            
                                
                            <div className="faq-wrap pl-30 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                                <div className="accordion" id="accordionExample">
                                    {faqData.map((item, index) => (
                                        <div className="card" key={index}>
                                            <div className="card-header" id={item.id}>
                                                <h2 className="mb-0">
                                                    <button className={`faq-btn${activeIndex === index ? '' : ' collapsed'} c-aboutcard`}
                                                        data-bs-target={`#collapse${index}`}
                                                        onClick={() => handleToggle(index)} >
                                                        {item.question}
                                                    </button>
                                                </h2>
                                            </div>
                                            <div 
                                            id={`collapse${index}`}
                                                className={`collapse${activeIndex === index ? ' show' : ''}`}
                                                data-bs-parent="#accordionExample">
                                                <div className="card-body">{item.answer}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>   
            </section>
        </>
    )
}

export default AboutEle;